import { formatDateUs } from 'helpers/utils';
import { useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';

const CustomDateRangePicker = ({
  show,
  onHide,
  onApply,
  initialStartDate = '',
  initialEndDate = '',
  title = 'Selecionar Período Personalizado'
}) => {
  const [startDate, setStartDate] = useState(initialStartDate);
  const [endDate, setEndDate] = useState(initialEndDate);

  const handleApply = () => {
    if (startDate && endDate) {
      onApply(startDate, endDate);
      onHide();
    }
  };

  const handleClear = () => {
    setStartDate('');
    setEndDate('');
  };

  const handleQuickSelect = days => {
    const today = new Date();
    const start = new Date(today.getTime() - (days - 1) * 24 * 60 * 60 * 1000);
    setStartDate(formatDateUs(start));
    setEndDate(formatDateUs(today));
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Data Inicial</Form.Label>
              <Form.Control
                type="date"
                value={startDate}
                onChange={e => setStartDate(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Data Final</Form.Label>
              <Form.Control
                type="date"
                value={endDate}
                onChange={e => setEndDate(e.target.value)}
                min={startDate}
              />
            </Form.Group>
          </Col>
        </Row>

        <div className="mb-3">
          <Form.Label className="mb-2">Seleção Rápida:</Form.Label>
          <div className="d-flex gap-2 flex-wrap">
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => handleQuickSelect(7)}
            >
              Últimos 7 dias
            </Button>
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => handleQuickSelect(15)}
            >
              Últimos 15 dias
            </Button>
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => handleQuickSelect(30)}
            >
              Últimos 30 dias
            </Button>
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => handleQuickSelect(90)}
            >
              Últimos 90 dias
            </Button>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="falcon-default" onClick={handleClear}>
          Limpar
        </Button>
        <Button variant="outline-danger" onClick={onHide}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={handleApply}
          disabled={!startDate || !endDate}
        >
          Aplicar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomDateRangePicker;
